(function () {
	'use strict';

	angular.module('qbePortal').controller('QBListReducerController', 'quoteModelFactory', QBListReducerController);
	QBListReducerController.$inject = ['$scope', 'aggregatedRemoveService', 'quoteModelFactory'];

	function QBListReducerController($scope, aggregatedRemoveService, quoteModelFactory) {
		var vm = this;

		vm.$onInit = function () {
			vm.items = vm.list;
			vm.quoteModel = quoteModelFactory.create();
		}

		vm.removeItem = function (item) {
			vm.items.splice(vm.items.indexOf(item), 1);
			aggregatedRemoveService.markForDelete(vm.typeName, item);
			vm.update({
				name: vm.name,
				value: vm.items
			});
		}
	}

	angular.module('qbePortal').component('qbListReducer', {
		templateUrl: '../ngviews/components/qbListReducer.html',
		controller: QBListReducerController,
		controllerAs: 'vm',
		bindings: {
			list: '<',
			item: '<',
			name: '@',
			typeName: '@',
			update: '&',
		}
	});
})();
